import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { displayOptions } from '../data/actions';
import { resolveSceneUnits } from '../session/sceneUnits';

/**
 * Publishes the drawing's native unit into redux from `PartFile.dxfSceneUnits`.
 *
 * Dispatching from here rather than from the session keeps the session redux-free.
 * `null` / missing codes resolve as unitless.
 */
export const useDxfSceneUnits = (insunits: number | null): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    const { displayUnits, isUnitless } = resolveSceneUnits(insunits ?? 0);
    dispatch(displayOptions.receiveSceneUnits({ displayUnits, isUnitless }));
  }, [dispatch, insunits]);
};
